<template>
    <v-container
        id="create-user-form"
        fluid>
        <v-card outlined v-if="!update && !userSearchedAndNotFound">
            <v-card-title class="justify-center" v-if="!update">{{ $t('user.createNewUser') }}</v-card-title>
            <v-container>
                <v-card-subtitle class="pl-0" v-if="!update">{{ $t('user.pickUserIdentifier')}}</v-card-subtitle>
                <validation-observer ref="form">
                    <v-form @submit.prevent="onSubmit">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <v-select
                                dense
                                v-model="identifier"
                                :items="identifierOptions"
                                :error-messages="errors"
                                :label="$t('user.identifierType')"
                                required
                                >
                            </v-select>
                        </validation-provider>
                        <validation-provider v-if="identifier == 'email'" :name="$t('user.email')" rules="required|email" v-slot="{ errors }">
                            <v-text-field
                                dense
                                v-model="email"
                                :label="$t('user.email')"
                                :error-messages="errors"
                                clearable=""
                                >
                            </v-text-field>
                        </validation-provider>
                        <validation-provider v-if="identifier == 'username'" :name="$t('user.username')" rules="required" v-slot="{ errors }">
                            <v-text-field
                                dense
                                v-model="username"
                                :label="$t('user.username')"
                                :error-messages="errors"
                                clearable=""
                                >
                            </v-text-field>
                        </validation-provider>
                        <v-card-actions class="justify-center">
                            <v-btn class="ma-2" color="primary" outlined type="submit">{{$t("user.validate")}}</v-btn>
                        </v-card-actions>
                    </v-form>
                </validation-observer>
            </v-container>
        </v-card>
        <user-form v-if="update || userSearchedAndNotFound"
            :update = "update"
            :idUser = "$route.params.id"
            :user="user"
            :imposedEmail="email"
            :imposedUsername="username"/>
        <confirmation-dialog
            v-model="dialogConfirmation"
            :title = "$t('user.userAlreadyAssociated')"
            :text = "$t('user.userAlreadyAssociatedText')"
            />
        <confirmation-dialog
            v-model="forbiddenUser"
            :title = "$t('user.forbiddenIdentifier')"
            :text = "$t('user.forbiddenIdentifierText')"
            />
        <user-association-dialog
            v-if='dialogUserAssociation'
            v-model='dialogUserAssociation'
            @close='closeUserAssociation'
            :userId='user.id'
            :user='user'
        />
    </v-container>
</template>

<script>

import { mapState } from 'vuex'

import { ValidationProvider, ValidationObserver } from 'vee-validate';

import UserForm from '../../components/users/UserForm'

import confirmationDialog from '../../components/dialogs/InformationDialog'
import userAssociationDialog from '../../components/dialogs/UserAssociationDialog'

export default {
    name: "userCreate",
    components: {
        "validation-provider": ValidationProvider,
        "validation-observer": ValidationObserver,
        "user-form": UserForm,
        "confirmation-dialog": confirmationDialog,
        "user-association-dialog": userAssociationDialog
    },
    data () {
        return {
            update: false,
            email: undefined,
            username: undefined,
            identifierOptions: [
                {text:this.$t('user.username'), value:"username"},
                {text:this.$t('users.email'), value:"email"},
            ],
            identifier: "username",
            user: undefined,
            userSearchedAndNotFound: false,
            dialogConfirmation: false,
            dialogUserAssociation: false,
            forbiddenUser: false
        }
    },
    computed: {
        ...mapState(['currentGroup'])
    },
    mounted () {
        if(this.$route.params.id){
            this.update = true
        }
    },
    methods: {
        onSubmit: function() {
            this.$refs.form.validate().then(success => {
                if(success){
                    if(this.identifier == "email"){
                        this.getUserByEmail()
                    }
                    else if(this.identifier == "username"){
                        this.getUserByUsername()
                    }

                }
            })
        },
        getUserByEmail () {
            this.user = undefined
            let myInit = {
                headers: {
                  Authorization: "Bearer " + this.$auth.accessToken,
                },
                queryStringParameters: {
                  email: this.email
                }
            };
            this.$Amplify.API.get('users', '/user', myInit)
            .then((res) => {
                this.user = res.user
                this.checkUser()
            })
            .catch((e) => {
                let error = e.response
                if(error.status && error.status == 404){
                    this.username = undefined
                    this.userSearchedAndNotFound = true
                }
                else {
                    console.log(e)
                }
            })
        },
        getUserByUsername () {
            this.user = undefined
            let myInit = {
                headers: {
                  Authorization: "Bearer " + this.$auth.accessToken,
                },
                queryStringParameters: {
                  username: this.username
                }
            };
            this.$Amplify.API.get('users', '/user', myInit)
                .then((res) => {
                    this.user = res.user
                    this.checkUser()
                })
                .catch((e) => {
                    let error = e.response
                    if(error.status && error.status === 404){
                        this.email = undefined
                        this.userSearchedAndNotFound = true
                    }
                    else {
                        console.log(e)
                    }
                })
        },
        checkUser(){
            let userIsRegistered = false
            let authorizedUser = false
            if(this.user.memberships){
                for(const membership of this.user.memberships){
                    if(membership.groupId == this.currentGroup.id){
                        authorizedUser = true
                    }
                }
            }
            if(authorizedUser){
                if(this.user.registrations){
                    userIsRegistered = this.user.registrations.some(registration => registration.applicationId === process.env.VUE_APP_SSO_APP_ID)
                }
                if(userIsRegistered){
                    this.dialogConfirmation = true
                }
                else {
                    this.dialogUserAssociation = true
                }
            }
            else {
                this.forbiddenUser = true
            }
        },
        closeUserAssociation() {
            this.dialogUserAssociation = true
            this.$router.push('/users')
        },
    }
}
</script>
